import React from 'react';
import {Row, Col, Card} from 'react-materialize';


import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

const Sobre = () => (

    <Card>

        <Row>
            <div align="center">
                <h5><p><b><FormattedMessage id={"what_is_sars_title"} defaultMessage={"O que é SARS-COV-2?"}/></b></p></h5>
            </div>
            <div align="justify" style={{padding:"50px"}}>
                <ul>
                    <li>• <FormattedMessage id={"what_is_sars_text_1"} defaultMessage={" A doença de coronavírus 2019 (COVID-19) é causada por um vírus recém-descoberto."}/></li>
                    <li>• <FormattedMessage id={"what_is_sars_text_2"} defaultMessage={"O ICTV (Comitê Internacional de Taxonomia de Vírus) designou oficialmente o nome do novo coronavírus como vírus SARS-COV-2 (Síndrome Respiratória Aguda Grave)."}/></li>
                    <li>• <FormattedMessage id={"what_is_sars_text_3"} defaultMessage={"A família Coronaviridae possui diferentes tipos de coronavírus. Alguns causam doenças respiratórias graves e são chamados SARS-COV, como SARS-COV (China 2002/2003) e MERS-COV (Oriente Médio, Arábia Saudita 2012)."}/></li>
                </ul>
            </div>
        </Row>

        <Row>
            <div align="center">
                <a href={"/covid"} style={{background:'white', color: 'black'}}>
                    <button style={{backgroundColor:"#7F7FFF", border:"white", borderRadius:"15px"}}>
                        <h5><FormattedMessage id={"back"} defaultMessage={"VOLTAR"}/></h5>
                    </button>
                </a>
            </div>
        </Row>

        

    </Card>

);

export default Sobre;